export const QueryKeys = {
  CART: 'cart',
  CART_ITEMS_INFO: 'cartItemsInfo',
  FAVORITE: 'favorite',
} as const;
